import React from 'react';
import { Header, SpaceBetween, Box, Select, Toggle } from '@cloudscape-design/components';
import { HeaderProps } from '../../types';

const PageHeader: React.FC<HeaderProps & { title: string }> = ({
  title,
  environment,
  onEnvironmentChange,
  timePeriod,
  onTimePeriodChange,
  darkMode,
  onDarkModeChange,
}) => {
  return (
    <Header
      variant="h1"
      actions={
        <SpaceBetween direction="horizontal" size="l">
          <Box>
            <SpaceBetween direction="vertical" size="xs">
              <Box fontSize="body-s" fontWeight="bold">
                Time period
              </Box>
              <Select
                options={[
                  {
                    label: 'Daily',
                    value: 'daily',
                  },
                  {
                    label: 'Weekly',
                    value: 'weekly',
                  },
                  {
                    label: 'Monthly',
                    value: 'monthly',
                  },
                  {
                    label: 'Yearly',
                    value: 'yearly',
                  },
                ]}
                placeholder="Select time period"
                selectedOption={timePeriod}
                onChange={({ detail }) => onTimePeriodChange(detail.selectedOption)}
              />
            </SpaceBetween>
          </Box>
          <Box>
            <SpaceBetween direction="vertical" size="xs">
              <Box fontSize="body-s" fontWeight="bold">
                Theme
              </Box>
              <Toggle
                checked={darkMode}
                onChange={({ detail }) => onDarkModeChange(detail.checked)}
              >
                Dark mode
              </Toggle>
            </SpaceBetween>
          </Box>
        </SpaceBetween>
      }
    >
      {title}
    </Header>
  );
};

export default PageHeader;
